import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { UserType } from '../types/auth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedUserTypes: UserType[];  // Removed the optional '?' marker
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  allowedUserTypes
}) => {
  const { isAuthenticated, userType, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    // You might want to show a loading spinner here
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    // Redirect to login page with return URL
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedUserTypes && userType && !allowedUserTypes.includes(userType)) {
    // Redirect to home if user type is not allowed
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
